import React, { useState } from 'react';
import { Button } from 'react-admin';
import { Delete as DeleteIcon } from '@mui/icons-material';
import DeleteWithConfirmationDialog from './DeleteWithConfirmationDialog';
import { Box } from '@mui/material';

interface CustomDeleteButtonProps {
  record: any;
  resource: string;
  nameField: string;
  displayName?: string;
  sx?: any;
  label?: boolean | string;
  redirectTo?: string;
}

const CustomDeleteButton: React.FC<CustomDeleteButtonProps> = ({
  record,
  resource,
  nameField,
  displayName,
  sx,
  label = false,
  redirectTo,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  const combinedSx = {
    minWidth: '32px',
    width: '32px',
    height: '32px',
    padding: '4px',
    ...sx, // Combinar estilos por defecto con los personalizados
  };

  return (
    <>
      <Button 
        onClick={handleClick} 
        label={label}
        color='error'
        sx={combinedSx}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <DeleteIcon sx={{ fontSize: '18px' }} />
        </Box>
      </Button>

      <DeleteWithConfirmationDialog
        open={dialogOpen}
        onClose={handleClose}
        record={record}
        resource={resource}
        nameField={nameField}
        displayName={displayName}
        redirectTo={redirectTo}
      />
    </>
  );
};

export default CustomDeleteButton;